import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportistaService {
  private ENDPOINT = environment.ENDPOINTS.TRANSPORTISTA;

  constructor(
    private http: HttpClient
  ) { }

  saveTransportista(data: any) {
    return this.http.post<any>(`${this.ENDPOINT}`, data);
  }

  updateTransportista(data: any) {
    return this.http.put<any>(`${this.ENDPOINT}`, data);
  }


  getTransportistas() {
    return this.http.get<any[]>(`${ this.ENDPOINT }`);
  }


}
